import { directiveEntryFormSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps.constant'
import { MaintenanceForwardingsRequiredDirectiveStepsData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import z from 'zod'

export const buildDynamicSchema = (requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData) => {
  const keys = Object.keys(requiredDirectiveSteps) as Array<keyof typeof directiveEntryFormSteps>

  let dynamicShape = z.object({})

  keys.forEach((key) => {
    const schemaForStep = directiveEntryFormSteps[key]?.schema

    if (schemaForStep) {
      dynamicShape = dynamicShape.merge(schemaForStep)
    }
  })

  return dynamicShape
}
